interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <nav className="mt-10 flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center justify-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-base" />
        上一页
      </button>
      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          aria-current={item === page ? "page" : undefined}
          className={
            item === page
              ? "h-9 w-9 cursor-pointer rounded-md bg-primary-500 text-sm font-medium text-background-50"
              : "h-9 w-9 cursor-pointer rounded-md border border-background-200 bg-background-50 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          }
        >
          {item}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center justify-center gap-1 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line text-base" />
      </button>
    </nav>
  );
}